import { Injectable } from "@angular/core";
import {
	Chord, ChordPerformanceType, Instrument, Melody, Performance,
	Seconds, TimedChord, UnpitchedNote
} from "../model/music";
import { Bpm, RhythmScore } from "../model/rhythm";

/**
 * Creates musical data.
 */
@Injectable()
export class MusicService {

	/**
	 * When saying "one", "two" or other numbers, the beat is not at the very
	 * beginning of the sound, but a little bit later. This is this offset.
	 */
	static countInSoundOffset: Seconds = 0.2


	createChordPerformance(chord: Chord, instrument: Instrument,
	                       type: ChordPerformanceType, gap: Seconds = 1): Performance {
		let notes: TimedChord[] = []
		if (type == "Synchronous")
			gap = 0
		for (let i = 0; i < chord.notes.length; i++) {
			let index = (type == "Upwards" ? i : chord.notes.length - i - 1)
			let note = chord.notes[index]
			let startTime: Seconds = i * gap
			let timedNote = new TimedChord(new Chord([note], chord.duration), startTime)
			notes.push(timedNote)
		}
		return new Performance([new Melody(notes, instrument)])
	}

	createRhythmPerformance(score: RhythmScore, rhythm = true, baseOnBeat = true, countIn: "None" | "Voice" | "Klick" = "None"): Performance {
		let quarter: Seconds = 60 / score.tempo
		let sixteenths: Seconds = quarter / 4
		let startTime: Seconds = 0
		//count in
		let countInMelody: Melody = new Melody([], (countIn == "Voice" ? "Numbers" : "Drums"), 0.3)
		if (countIn != "None") {
			for (let number = 1; number <= 4; number++) {
				let note = new UnpitchedNote(countIn == "Voice" ? ""+number : "Klick")
				let timedChord = new TimedChord(new Chord([note], quarter), startTime)
				countInMelody.timedChords.push(timedChord)
				startTime += quarter
			}
		}
		//base drum on beat
		let beatMelody: Melody = new Melody([], "Drums", 1)
		if (baseOnBeat) {
			let note = new UnpitchedNote("Base")
			for (let i = 0; i < 4 * (2 + (countIn ? 1 : 0)); i++) {
				let time = i * quarter + MusicService.countInSoundOffset
				let timedChord = new TimedChord(new Chord([note], quarter), time)
				beatMelody.timedChords.push(timedChord)
			}
		}
		//rhythm
		startTime += MusicService.countInSoundOffset
		let rhythmMelody: Melody = new Melody([], "Drums", 0.8)
		if (rhythm) {
			for (let note of score.notes) {
				let time: Seconds = startTime + note.time * 4 * quarter
				let timedChord = new TimedChord(new Chord([new UnpitchedNote("Snare")], sixteenths), time)
				rhythmMelody.timedChords.push(timedChord)
			}
		}
		return new Performance([countInMelody, beatMelody, rhythmMelody])
	}

	createDrumBeatPerformance(): Performance {
		let timedChord = new TimedChord(new Chord([new UnpitchedNote("Snare")], 0.2), 0)
		return new Performance([new Melody([timedChord], "Drums", 0.8)])
	}

}


// WEBPACK FOOTER //
// ./src/service/music.service.ts